//
//
//
//
//
//
//
//
//

export default {
  name: "SearchBox",
  created () { },
  props: ["value"],
  data () {
    return {
      keyword: this.value
    };
  },
  watch: {
    keyword: function () {
      this.$emit("input", this.keyword);
    }
  },
  methods: {
    search: function () {
      this.$emit("search");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/SearchBox.vue